"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagVE = function FlagVE(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-32.55H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-50.49,29.38l1.77,5.3,5.59,0a.75.75,0,0,1,.45,1.36l-4.5,3.32,1.68,5.33a.75.75,0,0,1-1.15.84l-4.55-3.25-4.55,3.25a.76.76,0,0,1-1.16-.84l1.69-5.33-4.5-3.32a.75.75,0,0,1,.44-1.36l5.59,0,1.77-5.3a.75.75,0,0,1,1.43,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-39.62,12.48l-1,5.52,4.91,2.68a.76.76,0,0,1-.25,1.41l-5.54.8-1,5.5a.76.76,0,0,1-1.42.19l-2.48-5-5.54.72A.75.75,0,0,1-52.54,23l4-3.9L-50.93,14a.76.76,0,0,1,1-1l4.95,2.61,4.07-3.84a.75.75,0,0,1,1.26.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-25.87-2.3-28.5,2.64l3.83,4.08A.76.76,0,0,1-25.35,8l-5.51-1-2.7,4.9A.76.76,0,0,1-35,11.65l-.78-5.54-5.49-1.06a.75.75,0,0,1-.19-1.41l5-2.46-.7-5.55A.76.76,0,0,1-35.81-5l3.89,4,5.06-2.38a.76.76,0,0,1,1,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-9.32-11.47l-3.86,4.05,2.58,5a.75.75,0,0,1-1,1l-5.05-2.42-3.92,4a.75.75,0,0,1-1.28-.63L-21.1-6l-5-2.5a.75.75,0,0,1,.2-1.41l5.5-1,.83-5.53a.75.75,0,0,1,1.41-.25l2.66,4.92,5.52-.92a.76.76,0,0,1,.67,1.27Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.7-15.72,4.89-12.86,6.05-7.38a.75.75,0,0,1-1.23.72L.61-10.34-4.24-7.55a.76.76,0,0,1-1.07-1l2.2-5.14-4.15-3.75a.75.75,0,0,1,.57-1.31l5.58.5,2.27-5.1a.76.76,0,0,1,1.43.14l1.24,5.45,5.56.59a.76.76,0,0,1,.31,1.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M74.09,29.38l-1.77,5.3-5.59,0a.75.75,0,0,0-.45,1.36l4.5,3.32-1.69,5.33a.76.76,0,0,0,1.16.84l4.55-3.25,4.56,3.25a.75.75,0,0,0,1.15-.84l-1.69-5.33,4.5-3.32a.75.75,0,0,0-.44-1.36l-5.59,0-1.77-5.3a.75.75,0,0,0-1.43,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M63.22,12.48l1,5.52-4.91,2.68a.76.76,0,0,0,.26,1.41l5.53.8,1,5.5a.75.75,0,0,0,1.41.19l2.47-5,5.55.72A.75.75,0,0,0,76.14,23l-4-3.9L74.53,14a.76.76,0,0,0-1-1l-5,2.61-4.07-3.84a.75.75,0,0,0-1.26.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49.47-2.3l2.62,4.94L48.27,6.72A.76.76,0,0,0,49,8l5.51-1,2.7,4.9a.76.76,0,0,0,1.41-.26l.78-5.54,5.49-1.06A.75.75,0,0,0,65,3.64L60,1.18l.7-5.55A.76.76,0,0,0,59.41-5L55.52-1,50.46-3.34a.76.76,0,0,0-1,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.92-11.47l3.86,4.05-2.58,5a.76.76,0,0,0,1,1l5-2.42,3.92,4a.75.75,0,0,0,1.28-.63L44.7-6l5-2.5a.75.75,0,0,0-.2-1.41L44-11l-.82-5.53a.75.75,0,0,0-1.41-.25l-2.66,4.92-5.52-.92a.76.76,0,0,0-.67,1.27Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.9-15.72l4.8,2.86L17.55-7.38a.75.75,0,0,0,1.23.72L23-10.34l4.85,2.79a.76.76,0,0,0,1.07-1L26.7-13.64l4.16-3.75a.76.76,0,0,0-.58-1.31l-5.57.5-2.28-5.1a.75.75,0,0,0-1.42.14l-1.24,5.45-5.56.59a.76.76,0,0,0-.31,1.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagVE;
exports["default"] = _default;